import * as React from 'react';

import { HeroPattern } from '@/components/hero-pattern';

import { Footer } from './footer';

export function SectionFooter() {
  return (
    <section className="relative redesign-container py-8 md:pt-12  flex justify-center flex-col ">
      <Footer />
      <HeroPattern className="isolate rotate-180" />
    </section>
  );
}
